// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsSample2-Sample2Settings-Sample2Settings-module__box--wjnBA {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 450px;
  padding: 24px 0 32px 0;
}
.src-businessServices-services-bsSample2-Sample2Settings-Sample2Settings-module__label--A0jOk {
  display: flex;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsSample2/Sample2Settings/Sample2Settings.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AACF;AACA;EACE,aAAA;EACA,QAAA;AACF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  max-width: 450px;\n  padding: 24px 0 32px 0;\n}\n.label {\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsSample2-Sample2Settings-Sample2Settings-module__box--wjnBA`,
	"label": `src-businessServices-services-bsSample2-Sample2Settings-Sample2Settings-module__label--A0jOk`
};
export default ___CSS_LOADER_EXPORT___;
